import React, { forwardRef } from "react";
import _ from "lodash";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { ICellRendererParams } from "ag-grid-community";
import { EditableCallbackParams } from "ag-grid-community/dist/lib/entities/colDef";

export const SelectRenderer = forwardRef<any, ICellRendererParams>((props, ref) => {
    const { value, valueFormatted, formatValue, colDef } = props;

    const classes = useClasses({
        editable: _.isFunction(colDef.editable) ? colDef.editable(props as EditableCallbackParams) : colDef.editable,
    });
    return (
        <div className={classes.wrapper} ref={ref}>
            <span className={classes.label}>{valueFormatted ?? formatValue?.(value)}</span>
            <span className="ag-icon ag-icon-tree-closed" role="presentation" />
        </div>
    );
});

export default SelectRenderer;

const useClasses = makeStyles<Theme, { editable: boolean }>({
    wrapper: ({ editable }) => ({
        height: 32,
        maxWidth: "100%",
        padding: 5,
        flexGrow: 1,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        backgroundColor: editable ? "white" : "#f6f6f6",
        border: "1px solid #E1E1E1",
        borderRadius: 4,
        "& .ag-icon-tree-closed": {
            transform: "rotate(90deg)",
        },
    }),
    label: {
        flexGrow: 1,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
});
